import Button from "../../../../../components/Button";
import Input from "../../../../../components/Input";
import { IconQuestion } from "../../../../../icons";
import { _formatDate } from "../../../../../libs/dateUtils";
import useTimeSheetStore from "../store/useStore";

export function RowFilterComponent() {
  const { dateFrom, setDateFrom, dateTo, setDateTo, bankHours, totalHours, setNeedSpinner, getPointsRange } = useTimeSheetStore();

  function handleFilterClick() {
    setNeedSpinner(true);
    getPointsRange(dateFrom, dateTo);
  }

  return (
    <div className="flex mt-5 justify-between items-center rounded-t-xl sm:flex-wrap">
      <div className="flex w-2/4">
        <Input
          setValue={(event: any) => setDateFrom(event.target.value)}
          value={_formatDate(dateFrom)}
          name="date"
          label="Data inicial"
          type="date"
          placeholder="Digite o período"
        />
        <Input
          setValue={(event: any) => setDateTo(event.target.value)}
          value={_formatDate(dateTo)}
          name="date"
          label="Data final"
          type="date"
          placeholder="Digite o período"
        />
        <Button className="bg-primary mt-10 px-20 font-bold h-16" onClick={handleFilterClick}>
          FILTRAR
        </Button>
      </div>
      <div className="font-bold text-2xl justify-center items-center mt-10 mr-10 font-new-source-sans-pro text-textPrimary w-2/4 sm:flex sm:flex-row sm:w-full">
        <span className="px-5 w-2/4 text-center">Horas do mês: {totalHours}</span>
        <span className="justify-center items-center h-4 w-2/4">
          Saldo:
          <span
            className={`rounded-xl mx-2 px-4 text-blueDark ${
              (bankHours == 0 && "bg-green-500") || (bankHours > 0 && "bg-red-600") || (bankHours < 0 && "bg-yellow-500")
            }`}
          >
            {bankHours > 0 && "+"}
            {bankHours}hrs
          </span>
          <span className="span-interrogation">{IconQuestion}</span>
        </span>
      </div>
    </div>
  );
}
